import React from 'react';


export default function ListRequerimentos() {


    return (
        <h1>Lista de Requerimentos</h1>
    );
}